import { Capacitor } from '@capacitor/core';

/**
 * Retourne true si l'app tourne dans un contexte Capacitor natif (Android / iOS).
 * Retourne false si on est dans un navigateur web classique.
 */
export const isNative = (): boolean => Capacitor.isNativePlatform();

/**
 * Retourne true si on est sur mobile — natif (Capacitor) ou PWA sur mobile.
 * Utile pour adapter l'UI ou les comportements sans forcément être en natif.
 */
export const isMobile = (): boolean => {
  if (isNative()) return true;
  // Détection PWA / navigateur mobile via user agent
  return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

/**
 * Retourne la plateforme courante : 'android' | 'ios' | 'web'
 */
export const getPlatform = (): 'android' | 'ios' | 'web' => {
  return Capacitor.getPlatform() as 'android' | 'ios' | 'web';
};

/**
 * Retourne true si on est sur Android natif.
 */
export const isAndroid = (): boolean => getPlatform() === 'android';

/**
 * Retourne true si on est sur iOS natif.
 */
export const isIOS = (): boolean => getPlatform() === 'ios';

/**
 * Retourne true si l'app est en mode PWA installée (standalone).
 */
export const isPWA = (): boolean => {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true
  );
};
